<template>
    <div class="sub-table flex-column flex-grow-auto" :class="{'z-border': border, 'z-auto': height == 'auto'}" :id="id" :style="{'height': sub.parsePixel(height)}">
		<div class="sub-table-body flex-column flex-grow-auto">
			<div class="sub-table-main flex-column flex-grow-auto">
				<sub-thead :store="store"></sub-thead>
				<sub-tbody :store="store" :auto-height="height == 'auto'"></sub-tbody>
			</div>
			
			<div v-show="columnsWidth.left > 1 && scrollXSize" class="sub-table-fixed-left flex-column" :style="{'bottom': `${scrollXSize}px`, 'width': `${columnsWidth.left}px`}">
				<sub-thead :store="store" fixed="left"></sub-thead>
				<sub-tbody :store="store" fixed="left"></sub-tbody>
			</div>
			
			<div v-show="columnsWidth.right > 1 && scrollXSize" class="sub-table-fixed-right flex-column" :style="{'bottom': `${scrollXSize}px`, 'right': `${scrollYSize}px`, 'width': `${columnsWidth.right}px`}">
				<sub-thead :store="store" fixed="right" :left="fixedRightShifting"></sub-thead>
				<sub-tbody :store="store" fixed="right" :left="fixedRightShifting"></sub-tbody>
			</div>
		
			<div v-show="scrollYSize" class="sub-table-head-scroll-place" :style="{'width': `${scrollYSize}px`, 'height': `${36 * header.length + 1}px`}"></div>
		</div>
		
		<div v-if="!value && paging" class="sub-table-foot flex-between-center">
			<div class="page-size flex-center">
				<span class="">共{{total}}条</span>
				<sub-select v-model="pageSize" :options="pageSizeOptions" :default-option="false"></sub-select>
			</div>
			<div class="page flex-center">
				<a class="sf sf-prev" :class="{'z-dis': pageIndex <= 1}" @click="update(1)"></a>
				<a class="sf sf-tri-left" :class="{'z-dis': pageIndex <= 1}" @click="update(pageIndex - 1)"></a>
				<span>第</span>
				<input v-model="pageIndex" type="text" @keyup.enter="update(pageIndex)">
				<span>页</span>
				<span>共{{pageCount}}页</span>
				<a class="sf sf-tri-right" :class="{'z-dis': pageIndex >= pageCount}" @click="update(pageIndex + 1)"></a>
				<a class="sf sf-next" :class="{'z-dis': pageIndex >= pageCount}" @click="update(pageCount)"></a>
				<a class="sf sf-refresh" @click="update(pageIndex)"></a>
			</div>
		</div>
		
		<div style="display:none;"><slot></slot></div>
    </div>
</template>

<script>
	import subThead from './thead.js'
	import subTbody from './tbody.js'
	import {createStore, mapState} from './store/index.js'
	
	let cTableIndex = 0;
	
	export default {
		name: 'cTable',
		
		components: {
			subThead, subTbody
		},
		
		props: {
			value: Array,  // 表格数据
			
			code: String,  // 表格code，用于获取字段
			
			height: [String, Number],  // 表格高度
			
			border: Boolean,  // 是否显示边框
			
			paging: {  // 是否分页
				type: Boolean,
				default: true
			}
		},
		
		data() {
			return {
				id: `cTableIndex${cTableIndex++}`,
				store: createStore(this),
				
				pageIndex: 1,
				total: 0,
				pageSize: 20,
				pageSizeOptions: [{
					name: '10条/页',
					value: 10
				}, {
					name: '20条/页',
					value: 20
				}, {
					name: '50条/页',
					value: 50
				}, {
					name: '100条/页',
					value: 100
				}]
			}
		},
		
		computed: {
			...mapState(['dataList', 'header', 'columnsWidth', 'scrollXSize', 'scrollYSize']),
            
            fixedRightShifting() {
                return this.columnsWidth.right - this.columnsWidth.all + 'px';
            },
			
			pageCount() {
				return Math.ceil(this.total / this.pageSize) || 1;
			}
		},
		
		watch: {
			dataList(val) {
				this._updateData = true;
                setTimeout(() => {
                    this._updateData = false;
                });
				this.$emit('input', Array.from(val, item => item.data));
				this.resize();
			},
			
			value(val) {
				if (this._updateData) {
					this._updateData = false;
				} else{
					this.store.setData(val);
				}
			},
			
			pageSize() {
				this.update(1);
			}
		},
		
		mounted() {
			this.$nextTick(() => {
				this.bindEvent();
			});
			this.resize();
			
			new Promise(resolve => {
				if (this.code) {
					this.request({
						url: '/system_table_field/get_table_field_list',
						data: {
							list_unique_code: this.code,
							enable_state: 1
						},
						success: data => {
							resolve(data);
						}
					});
				} else {
					resolve([]);
				}
			}).then(columnPower => {
				var list = [], selector, expand;
				this.$children.filter(item => item.$options.name == 'cTableColumn').forEach(col => {
					if (col.type == 'selector') {
						selector = col;
						return;
					} else if (col.type == 'expand') {
						expand = col;
						return;
					}
					
					let index = columnPower.findIndex(item => item.field_code == col.name),
						power = columnPower[index];
					
					if (power) {
						if (power.default_display == 1) {
							col.powerConfig = {
								fixed: power.is_locked == 2 ? 'left' : undefined
							}
							list.splice(index, 0, col);
						}
					} else {
						list.push(col);
					}
				});
				expand && list.unshift(expand);
				selector && list.unshift(selector);
				this.store.commit('columnConfig', list);
			});
			
			if (this.value) {
				this.store.setData(this.value);
			}
			
			this.store.commit('rowClick', !!this._events['row-click']);
		},
		
		activated() {
			this._hidden = false;
			this.resize();
		},
		
		deactivated() {
			this._hidden = true;
			this.store.commit('scrollX', false);
		},
		
		beforeDestroy() {
			window.removeEventListener('resize', this._resizeHandler);
		},
		
		methods: {
			bindEvent() {
				var $table = document.getElementById(this.id),
					$theadWrapper = document.querySelector('#' + this.id + ' .sub-table-main .sub-table-head-wrapper'),
					$tbodyWrapper = document.querySelector('#' + this.id + ' .sub-table-main .sub-table-body-wrapper'),
					$tbody = document.querySelector('#' + this.id + ' .sub-table-main .sub-table-body-wrapper table'),
					$fixedLeftTbodyWrapper = document.querySelector('#' + this.id + ' .sub-table-fixed-left .sub-table-body-wrapper'),
					$fixedRightTbodyWrapper = document.querySelector('#' + this.id + ' .sub-table-fixed-right .sub-table-body-wrapper');
					
				this._resizeHandler = () => {
					if (this._hidden) return;
					this.store.commit('scrollX', $table.clientWidth < this.columnsWidth.all + this.scrollYSize);
					this.store.commit('scrollY', $tbody.clientHeight > $tbodyWrapper.clientHeight);
				}
				
				window.addEventListener('resize', this._resizeHandler);
				$tbodyWrapper.onscroll = function() {
					$theadWrapper.scrollLeft = $tbodyWrapper.scrollLeft;
					$fixedLeftTbodyWrapper.scrollTop = $tbodyWrapper.scrollTop;
					$fixedRightTbodyWrapper.scrollTop = $tbodyWrapper.scrollTop;
				};
			},
			
			resize() {
				this.$nextTick(() => {
					this._resizeHandler();
				});
                setTimeout(() => {
                    this._resizeHandler();
                }, 100);
			},
			
			load(opt) {
				this.store.setData([]);
				this.opt = opt;
				this.update(1);
			},
			
			update(page) {
				if (!this.opt || !this.opt.url) return;
				
				page = parseInt(page || this.pageIndex) || 1;
				page = page < 1 ? 1 : page > this.pageCount ? this.pageCount : page;
				
				this.pageIndex = page;
				this.requestObj && this.requestObj.abort();
                let load = this.$loading({
                    dom: document.querySelector('#' + this.id)
                });
				this.requestObj = this.request({
					url: this.opt.url,
					data: Object.assign({
						pageIndex: page,
						pageSize: this.pageSize
					}, this.opt.data || {}),
					success: data => {
						try {
							document.querySelector('#' + this.id + ' .sub-table-main .sub-table-body-wrapper').scrollTop = 0;
						} catch(e) {}
						data = data || [];
						if (this.opt.dataFormatter) {
							data = this.opt.dataFormatter(data);
						}
						this.store.setData(data);
						this.store.commit('emptyState', !data.length);
					},
					response: res => {
						this.total = res.total;
                        load.close();
					}
				});
			},
			
			getRow(filter = 'all') {
				if (filter == 'all') {
					return this.dataList;
				} else if (filter == 'selected') {
					return this.getRow(item => item.selected);
				} else if (typeof filter == 'function') {
					let list = [];
					!function poll(arr) {
						if (!arr) return;
						arr.forEach((item, index) => {
							if (filter(item)) {
								list.push(item);
							}
							
							poll(item.expandData.children);
						});
					}(this.dataList);
					return list;
				} else {
					let list = [];
					(typeof filter != 'object' ? [filter] : filter).forEach(item => {
						list.push(this.dataList[item]);
					});
					return typeof filter == 'object' ? list : list[0];
				}
			},
			
			push(data) {
				this.store.dataList.push(this.store.createRow({
					data
				}));
			},
            
            insert(index, data) {
                if (index !== undefined) {
                    this.store.dataList.splice(index, 0, this.store.createRow({
                        data
                    }));
                }
            }
		}
	};
</script>

<style lang="stylus">
	@import './style/index'
</style>
